import { RootState } from '@algoan/dashboard/store/store';
import { AsyncStatus, Customer } from '@algoan/dashboard/model';
import { sortSelector } from '@algoan/dashboard/store/selectors';
import { CustomerListLoadingError } from '@algoan/dashboard/store/slice';

export const customerListSelector = (state: RootState): Customer[] => state.customer.customerList;

export const isCustomerListLoadingSelector = (state: RootState): boolean =>
  state.customer.customerListFetchingStatus === AsyncStatus.PENDING;

export const customerListErrorSelector = (state: RootState): CustomerListLoadingError =>
  state.customer.customerListError;

export const loadableCustomerNumberSelector = (state: RootState): number =>
  state.customer.pagination.totalResources ?? 0;

export const isSortingSelector = (state: RootState): boolean => sortSelector(state).sortLoading !== undefined;
